import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "components/common/dialog/Dialog";
import { useIdleHandler, UseIdleHandlerProps } from "hooks";

type IdleWarningDialogProps = Omit<UseIdleHandlerProps, "onIdle"> & {
  onLogout: UseIdleHandlerProps["onIdle"];
};

export const IdleWarningDialog: React.FC<IdleWarningDialogProps> = ({
  onLogout,
  timeout,
  warningTime = 30000,
  enabled = true,
}) => {
  const { t } = useTranslation(["app"]);
  const { showWarning, continueSession } = useIdleHandler({
    enabled,
    timeout,
    warningTime,
    onIdle: onLogout,
  });

  return (
    <>
      {showWarning && (
        <Dialog
          icon="warning"
          dialogClosed={continueSession}
          primaryActionLabel={t("app:idle_warning_continue")}
          primaryActionHandler={continueSession}
          type="warning"
        >
          {t("app:idle_warning_message")}
        </Dialog>
      )}
    </>
  );
};
